/**
 * Created by Ram on 3/04/2017.
 */

import React, { Component } from "react";
import DeviceManagement from "../presentation/DeviceManagement";

class DeviceManagementWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      devicesRegistered: [],
      devicesNew: [],
      search: "",
      searchNew: "",
      sort: "name",
      sortAsc: true,
      sortNew: "creationTime",
      sortNewAsc: false,
      showEditDeviceForm: false,
      editDevice: {
        name: "",
        mobileNumber: "",
        serialNumber: "",
        imei: "",
        os: "",
        osVersion: "",
        model: "",
        deviceType: "",
        udid: "",
        identifier: "",
        trackingDevice: false,
        deviceId: ""
      },
      editDeviceError: {
        error: false,
        errorField: "",
        success: "",
        serverError: ""
      }
    };

    this.emptyState = {
      name: "",
      mobileNumber: "",
      serialNumber: "",
      imei: "",
      os: "",
      osVersion: "",
      model: "",
      deviceType: "",
      udid: "",
      identifier: "",
      trackingDevice: false,
      deviceId: ""
    };
  }

  componentDidMount() {
    this.getRegisteredDeviceList();
    this.getNewDeviceList();
  }

  updateData = device => {
    this.props.navigator.requestEditDevice(device._id);
  };

  deleteDevice = deviceId => {
    if (confirm("Are you sure you want to delete this device?")) {
      fetch("/service/deleteDevice", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({ deviceId: deviceId })
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            this.getRegisteredDeviceList();
            this.getNewDeviceList();
          });
        }
      });
    }
  };

  getRegisteredDeviceList = callback => {
    this.setState({ isLoading: true }, () => {
      fetch(
        "/service/devices?search=" +
          this.state.search +
          "&sort=" +
          this.state.sort +
          "&sortAsc=" +
          this.state.sortAsc +
          "&registeredOnly=true",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "same-origin"
        }
      ).then(response => {
        if (response.status !== 200) {
          this.setState({ isLoading: false });
        } else {
          response.json().then(json => {
            this.setState(
              { devicesRegistered: json, isLoading: false },
              callback
            );
          });
        }
      });
    });
  };

  getNewDeviceList = callback => {
    fetch(
      "/service/devices?search=" +
        this.state.searchNew +
        "&sort=" +
        this.state.sortNew +
        "identifier&sortAsc=" +
        this.state.sortNewAsc +
        "&newOnly=true",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(json => {
          this.setState({ devicesNew: json }, callback);
        });
      }
    });
  };

  updateSearchState = e => {
    this.setState({ search: e.target.value }, () => {
      this.getRegisteredDeviceList();
    });
  };

  updateSearchNewState = e => {
    this.setState({ searchNew: e.target.value }, () => {
      this.getNewDeviceList();
    });
  };

  updateSortState = sortBy => {
    this.setState(prevState => {
      return sortBy === prevState.sort
        ? { sortAsc: !prevState.sortAsc }
        : { sort: sortBy };
    }, this.getRegisteredDeviceList);
  };

  updateSortNewState = sortBy => {
    this.setState(prevState => {
      return sortBy === prevState.sortNew
        ? { sortNewAsc: !prevState.sortNewAsc }
        : { sortNew: sortBy };
    }, this.getNewDeviceList);
  };

  getDeviceDetails = () => {
    fetch(
      "/service/getDeviceDetails?deviceId=" + this.state.editDevice.deviceId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(device => {
          this.setState({
            editDevice: {
              device: device,
              name: device.name,
              mobileNumber: device.mobileNumber,
              serialNumber: device.serialNumber,
              imei: device.imei,
              os: device.os,
              osVersion: device.osVersion,
              model: device.model,
              deviceType: device.deviceType,
              udid: device.udid,
              identifier: device.identifier,
              trackingDevice: device.trackingDevice
            }
          });
        });
      }
    });
  };

  updateDeviceState = e => {
    let { editDevice } = { ...this.state };
    if (e.target.name === "trackingDevice") {
      editDevice[e.target.name] = !editDevice.trackingDevice;
    } else {
      editDevice[e.target.name] = e.target.value;
    }
    this.setState({ editDevice });
  };

  validateInput = () => {
    if (this.state.editDevice.name === "") {
      this.setState({
        editDeviceError: {
          error: "Please enter a device name",
          errorField: "name"
        }
      });
    } else if (this.state.editDevice.mobileNumber === "") {
      this.setState({
        editDeviceError: {
          error: "Please enter a mobile number ",
          errorField: "mobileNumber"
        }
      });
    } else if (this.state.editDevice.serialNumber === "") {
      this.setState({
        editDeviceError: {
          error: "Please enter a serial number",
          errorField: "serialNumber"
        }
      });
    } else if (this.state.editDevice.imei === "") {
      this.setState({
        editDeviceError: { error: "Please enter imei", errorField: "imei" }
      });
    } else if (
      this.state.editDevice.os === "" ||
      this.state.os === "Select OS"
    ) {
      this.setState({
        editDeviceError: { error: "Please select OS", errorField: "os" }
      });
    } else if (this.state.editDevice.osVersion === "") {
      this.setState({
        editDeviceError: {
          error: "Please enter OS version",
          errorField: "osVersion"
        }
      });
    } else if (this.state.editDevice.model === "") {
      this.setState({
        editDeviceError: { error: "Please enter model", errorField: "model" }
      });
    } else if (
      this.state.editDevice.deviceType === "" ||
      this.state.deviceType === "Select Test device type"
    ) {
      this.setState({
        editDeviceError: {
          error: "Please select a device type",
          errorField: "deviceType"
        }
      });
    } else {
      this.setState({ editDeviceError: { error: false } });
      return true;
    }
  };

  handleEditDevice = () => {
    const o = { ...this.state.editDevice };
    const body = {
      name: o.name,
      mobileNumber: o.mobileNumber,
      serialNumber: o.serialNumber,
      imei: o.imei,
      os: o.os,
      osVersion: o.osVersion,
      model: o.model,
      deviceType: o.deviceType,
      udid: o.udid,
      identifier: o.identifier,
      trackingDevice: o.trackingDevice,
      deviceId: o.deviceId
    };

    this.setState({ editDeviceError: { serverError: "", success: "" } });

    if (this.validateInput()) {
      fetch("/service/editDevice", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status !== 200) {
          response.json().then(json => {
            this.setState({
              editDeviceError: {
                serverError: json.errorMessage,
                errorField: json.errorField,
                success: ""
              }
            });
          });
        } else {
          this.getNewDeviceList(() => {
            this.getRegisteredDeviceList(() => {
              let { editDevice } = { ...this.state };
              //Clear error messages
              this.setState({
                editDeviceError: {
                  success: "Device details updated successfully",
                  errorField: "",
                  serverError: ""
                },
                editDevice,
                editDevicePreviousState: { ...editDevice }
              });
            });
          });
        }
      });
    }
  };

  handleAddDevice = () => {
    let body = {
      name: this.state.editDevice.name,
      mobileNumber: this.state.editDevice.mobileNumber,
      serialNumber: this.state.editDevice.serialNumber,
      imei: this.state.editDevice.imei,
      os: this.state.editDevice.os,
      osVersion: this.state.editDevice.osVersion,
      model: this.state.editDevice.model,
      deviceType: this.state.editDevice.deviceType,
      udid: this.state.editDevice.udid,
      identifier: this.state.editDevice.identifier,
      trackingDevice: this.state.editDevice.trackingDevice
    };

    this.setState({ editDeviceError: { serverError: "", success: "" } });

    if (this.validateInput()) {
      fetch("/service/createDevice", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status !== 200) {
          response.json().then(json => {
            this.setState({
              editDeviceError: {
                serverError: json.errorMessage,
                errorField: json.errorField,
                success: ""
              }
            });
          });
        } else {
          this.setState({
            editDeviceError: {
              success: "Device details updated successfully",
              errorField: "",
              serverError: ""
            }
          });
          this.getRegisteredDeviceList();
          this.getNewDeviceList();
        }
      });
    }
  };

  showEditDeviceForm = (currentDevice = null) => {
    if (currentDevice) {
      let editDeviceState = Object.assign({}, currentDevice); //shallow copy to prevent object from being edited when form changes
      editDeviceState.deviceId = currentDevice._id;
      delete editDeviceState._id;
      editDeviceState.isNewDevice =
        editDeviceState.name.substr(0, 10) === "New device";
      this.setState({
        showEditDeviceForm: true,
        editDevice: editDeviceState,
        editDevicePreviousState: { ...editDeviceState }
      });
    } else {
      this.setState({
        showEditDeviceForm: true,
        editDevicePreviousState: { ...this.emptyState }
      });
    }
    document.getElementsByTagName("html")[0].classList.add("no-scroll");
  };

  hideEditDeviceForm = () => {
    let emptyErrorState = {
      error: false,
      errorField: "",
      success: "",
      serverError: ""
    };

    if (
      JSON.stringify(this.state.editDevice) ===
        JSON.stringify(this.state.editDevicePreviousState) ||
      confirm("Discard changes?")
    ) {
      this.setState({
        showEditDeviceForm: false,
        editDevice: { ...this.emptyState },
        editDevicePreviousState: { ...this.emptyState },
        editDeviceError: emptyErrorState
      });
      document.getElementsByTagName("html")[0].classList.remove("no-scroll");
    }
  };

  render() {
    return (
      <DeviceManagement
        navigator={this.props.navigator}
        loadData={this.state}
        updateData={this.updateData}
        updateSearchState={this.updateSearchState}
        updateSearchNewState={this.updateSearchNewState}
        updateSortState={this.updateSortState}
        updateSortNewState={this.updateSortNewState}
        deleteDevice={this.deleteDevice}
        getDeviceDetails={this.getDeviceDetails}
        updateDeviceState={this.updateDeviceState}
        validateInput={this.validateInput}
        handleEditDevice={this.handleEditDevice}
        handleAddDevice={this.handleAddDevice}
        showEditDeviceForm={this.showEditDeviceForm}
        hideEditDeviceForm={this.hideEditDeviceForm}
      />
    ); //return
  } //render
} //DeviceManagementWidget

export default DeviceManagementWidget;
